import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import QrReader from 'react-qr-reader'

const styles = theme => ({
  root: {
    padding: 16,
    margin: 16
  },
  stepTitle: {
    marginBottom: 30
  },
  error: {
    color: "red",
    fontWeight: "bold"
  }
});

class Qr extends React.Component {

  constructor(){
    super()
    this.state = {
      delay: 300,
      result: 'No result',
      error: null
    }

  }
  handleScan = (data) => {
    if (data) {
      // Parse terminal code from the qr data (which is an url)
      const re = /terminal=(.*)/;
      const result = re.exec(data);
      if(result == null) {
        this.handleError("Terminal code not found in QR.");
        return;
      }
      if (result.length >= 1) {
        const terminalCode = result[1];
        this.props.handleChangeMode();
        this.props.handleChangeTerminalCodeValue(terminalCode);
      }
    }
  }

  handleError = (err) => {
    let errorMessage = "";
    if (typeof err !== "string") {
      errorMessage = "Unknown error";
    } else {
      errorMessage = err;
    }
    this.setState({error: errorMessage});
    console.error(err)
  }

  // // Uncomment to test qr with image upload
  // openImageDialog() {
  //   this.refs.qrReader1.openImageDialog()
  // }


  render() {
    const { classes } = this.props;
    const { error } = this.state;

    return (
      <React.Fragment>
          <div>
            <QrReader ref="qrReader1"
              delay={this.state.delay}
              onError={this.handleError}
              onScan={this.handleScan}
              style={{ width: '100%' }}
              // // Uncomment to test qr with image upload
              // legacyMode={true}
            />
            {error != null &&
            <div>
              <div>{this.state.result}</div>
              <div><Typography className={classes.error}>Error: {this.state.error}</Typography></div>
            </div>}
          </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Qr);



// WEBPACK FOOTER //
// ./src/components/Steps/Qr.js